export default __webpack_public_path__ + "static/media/tech-android.1b885245.svg";